import { useEffect } from "react";
import { ErrorLike } from "@apollo/client";

import useTypedContext from "hooks/useTypedContext";
import useErrorHandle from "hooks/useErrorHandle";

import { StackFormContext } from "./context";

const useErrorHandlerNewStack = (error?: ErrorLike) => {
  const { setAccountOrAuthErrorContent } = useTypedContext(StackFormContext);

  const AccountOrAuthErrorContent = useErrorHandle(error);

  useEffect(() => {
    if (AccountOrAuthErrorContent) {
      setAccountOrAuthErrorContent(AccountOrAuthErrorContent);
    }
  }, [AccountOrAuthErrorContent, setAccountOrAuthErrorContent]);
};

export default useErrorHandlerNewStack;
